module.exports = __webpack_public_path__ + "img/s_5.2d9cc13b.png";